import PropTypes from 'prop-types';

export const propTypes = {
    translation: PropTypes.object,
};
